import { useEffect } from 'react';
// modules
import { useStore } from 'modules/Stores';
import { MARKET_FEEDER_MODES } from 'modules/LiveData/constants';

export default <T extends MARKET_FEEDER_MODES>(
  instrumentKey: string,
  dataType: T,
  subscribe = true,
) => {
  const { subscribeScrip, unsubscribeScrip, getByInstrumentKey } = useStore(
    'LiveDataStore',
  );

  const liveData = getByInstrumentKey(instrumentKey);

  useEffect(() => {
    if (subscribe && instrumentKey) {
      subscribeScrip([instrumentKey], dataType);
    }

    return () => {
      if (subscribe && instrumentKey) {
        unsubscribeScrip([instrumentKey], dataType);
      }
    };
  }, [instrumentKey, subscribeScrip, unsubscribeScrip, dataType, subscribe]);

  return liveData;
};
